import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetMunicipalitiesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetMunicipalitiesController.php
* @route '/api/company/{company}/elys/municipalities'
*/
const ElysGetMunicipalitiesController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ElysGetMunicipalitiesController.url(args, options),
    method: 'post',
})

ElysGetMunicipalitiesController.definition = {
    methods: ["post"],
    url: '/api/company/{company}/elys/municipalities',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetMunicipalitiesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetMunicipalitiesController.php
* @route '/api/company/{company}/elys/municipalities'
*/
ElysGetMunicipalitiesController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return ElysGetMunicipalitiesController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetMunicipalitiesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetMunicipalitiesController.php
* @route '/api/company/{company}/elys/municipalities'
*/
ElysGetMunicipalitiesController.post = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ElysGetMunicipalitiesController.url(args, options),
    method: 'post',
})

export default ElysGetMunicipalitiesController